import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import appActions from '../../../appActions';
import TaskHeader from './TaskHeader';
import TaskFilterBar from './TaskFilterBar';
import TaskPanel from './TaskPanel';
import storage from '../../../utils/storage';
import { isAdminRole, isEntAdmin } from '../../../utils/mics';
import TaskSidebar from './TaskSideBar';
import Sidebar from '../../../components/Sidebar';
import withNotification from '../../../hoc/withNotification';
import Loader from '../../../components/Loader';

const TaskBoard = () => {

    const dispatch = useDispatch();
    const [taskGroupList, setTaskGroupList] = useState([]);
    const [filterParams, setFilterParams] = useState({});
    const [activeGroup, setActiveGroup] = useState(null);
   // const [pageParams, setPageParams] = useState({});

    const loading = useSelector(state => state.task.isLoadingGetAllTask);
    const taskList = useSelector(state => state.task.taskList);
    const task = useSelector(state => state.task.task);
    const userInfo = useMemo(() => JSON.parse(storage.get('loginUser')), []);
    const { userRole, userId, siteId } = userInfo;

    const defaultParams = useMemo(() => ({
        pagesize: 50,
        pageno: 1,
    }), []);

    const fetchTasks = useCallback((params = {}) => {
        dispatch(appActions.TASK_GET_ALL_REQUEST({ ...defaultParams, ...params }));
    }, [dispatch, defaultParams]);

     useCallback((params = {}) => {
        dispatch(appActions.PRIORITY_GET_ALL_REQUEST({ ...params }));
    }, [dispatch]);

    useCallback((params = {}) => {
        dispatch(appActions.TASKTYPE_GET_ALL_REQUEST({ ...params }));
    }, [dispatch]);

    useCallback((params = {}) => {
        dispatch(appActions.REPEAT_GET_ALL_REQUEST({ ...params }));
    }, [dispatch]);

    useCallback((params = {}) => {
        dispatch(appActions.PROGRESS_GET_ALL_REQUEST({ ...params }));
    }, [dispatch]);

    useCallback((params = {}) => {
        dispatch(appActions.STORE_GET_ALL_REQUEST({ ...params }));
    }, [dispatch]);

    useCallback((params = {}) => {
        dispatch(appActions.SITEGROUPLIST_GET_ALL_REQUEST({ ...params }));
    }, [dispatch]);

    useCallback((params = {}) => {
        dispatch(appActions.USERLIST_GET_ALL_REQUEST({ ...params }));
    }, [dispatch]);

    useCallback((params = {}) => {
        dispatch(appActions.REMINDER_GET_ALL_REQUEST({ ...params }));
    }, [dispatch]);

    useEffect(() => {
        if (task?.action === 'delete' || task?.action === 'create' || task?.action === 'update' || task?.action === 'copy') {
            fetchTasks();
        }
    }, [task, fetchTasks]);

    useEffect(() => {
        const params = { ...defaultParams };
        
        // force reset taskList
        if (activeGroup) {
            dispatch(appActions.TASK_GET_ALL_FAILURE());
        }
        
        if (!activeGroup) {
            if (task.id) {
                fetchTasks();
                dispatch(appActions.TASK_RESET_SUCCESS());
            }
        };

        if (activeGroup === 'draft' && isEntAdmin(userRole)) {
            // params.taskGroupCode = siteId;
            params.assignedBy = userId;
            params.status = 'DRAFT';
        } else  if (activeGroup === 'DELETED' && isAdminRole(userRole)) {
            
            params.status = 'DELETED';
        } else if (activeGroup === 'mytask') {
            params.assignedTo = userId;
        }

        fetchTasks(params);
        
    }, [task, fetchTasks, dispatch, activeGroup, defaultParams, userRole, siteId, userId]);

    useEffect(() => {
        if (isEntAdmin(userRole)) {
            setActiveGroup('site');
            fetchTasks({ siteId: siteId });
        }
    }, [userRole, siteId, fetchTasks]);

    // useEffect(() => {
    //     if (!activeGroup) return;

    //     const params = { ...defaultParams };
    //     if (activeGroup === 'draft' && isEntAdmin(userRole)) {
    //         params.taskGroupCode = siteId;
    //         params.status = 'DRAFT';
    //     }else  if (activeGroup === 'DELETE' && isAdminRole(userRole)) {
    //         params.taskGroupCode = siteId;
    //         params.status = 'DELETE';
    //     } 
    //     else if (activeGroup === 'mytask') {
    //         params.assignedTo = userId;
    //     }

    //     const subTabsParams = { ...params };
    //     subTabsParams.activeGroup = activeGroup;
    //     setPageParams(subTabsParams);
        
    //     fetchTasks(params);
    // }, [activeGroup, userRole, userId, siteId, defaultParams, fetchTasks]);

    useEffect(() => {
        const groups = [];
        
        if(activeGroup === 'mytask') {
            const tasks = taskList.filter(task => task.status !== 'DRAFT')
            .map(task => ({...task, taskRecurrence: {...task.taskRecurrence}}));

            groups.push({
                title: 'Messages Assigned To Me',
                tasks: tasks,
            });
        } else if (activeGroup === 'draft') {
            const tasks = taskList.filter(task => task.status === 'DRAFT')
                              .map(task => ({...task, taskRecurrence: {...task.taskRecurrence}}));

            groups.push({
                title: 'Draft Messages',
                tasks: tasks,
            });
        } else if(activeGroup === 'site') {
            const tasks = taskList.filter(task => task.status !== 'DRAFT')
            .map(task => ({...task, taskRecurrence: {...task.taskRecurrence}}));

            groups.push({
                title: 'All Messages',
                tasks: tasks,
            });
        } else if(activeGroup === 'DELETED') {
            const tasks = taskList.filter(task => task.status !== 'DRAFT')
            .map(task => ({...task, taskRecurrence: {...task.taskRecurrence}}));

            groups.push({
                title: 'Deleted Messages',
                tasks: tasks,
            });
        }
        setTaskGroupList(groups);
    }, [taskList, activeGroup, userRole]);

    const handleFilterTask = useCallback((params) => {
        setFilterParams(params);
        fetchTasks(params);
    }, [fetchTasks]);

    const handleSearch = (param) => {
    }


    return (
        <>
           {loading && <Loader />}
            <TaskHeader handleSearch={handleSearch}/>
            <div className="flex flex-min-height">
                <Sidebar />
                <TaskSidebar 
                    userRole={userRole}
                    activeGroup={activeGroup}
                    setActiveGroup={setActiveGroup}
                />
                <div className="p-grid msg-panel-width">
                    <TaskFilterBar
                        handleFilter={handleFilterTask}
                        filterParams={filterParams}
                        userInfo={userInfo}
                        // pageParams={pageParams}
                    />
                    {taskGroupList.map((group, index) => (
                        <TaskPanel key={index} taskGroup={group} userRole={userRole} />
                    ))}
                </div>
            </div>
        </>
    );
};

//export default TaskBoard

export default withNotification(TaskBoard);
